import AuthService from "../login/auth.service";
import { creditos } from "../../components/generico/utils/UrlAPI";
import axios from "axios";
import { comprobantes } from "../../components/generico/utils/UrlAPI";


class PrestamoService {

    async resumenPrestamos() {
        var data = JSON.stringify({
          canal: "WEB",
        
        });
    
        var config = {
          method: "post",
          url: creditos + "creditos/resumen",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + AuthService.getCurrentToken(),
          },
          data: data,
        };
        return await axios(config);
      }

      async cuotasPrestamo(credito, modo) {
        var data = JSON.stringify({
            idCredito: credito,
            modo: modo,
            canal: "WEB",
        
        });
    
        var config = {
          method: "post",
          url: creditos + "creditos/cuotas",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + AuthService.getCurrentToken(),
          },
          data: data,
        };
       // console.log(data)
        return await axios(config);
      }
    
      async cuotasPendientes(credito, modo) {
        var data = JSON.stringify({
            idCredito: credito,
            modo: modo,
            canal: "WEB",
        
        });
    
        var config = {
          method: "post",
          url: creditos + "creditos/pagos",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + AuthService.getCurrentToken(),
          },
          data: data,
        };
      //  console.log(data)
        return await axios(config);
      }
      async cuotasPagar(credito, modo, cantCuotas, cuenta) {
        var data = JSON.stringify({
            idCredito: credito,
            modo: modo,
            canal: "WEB",
            cantCuotas: cantCuotas,
            cuentaDebito: cuenta 
        
        });
    
        var config = {
          method: "post",
          url: creditos + "creditos/pagos",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + AuthService.getCurrentToken(),
          },
          data: data,
        };
        //console.log(data)
        return await axios(config);
      }

      async descagarComponente(titulo, nroOperacion, nroSocioTitular, nroCredito, cuentaDebito, saldoCuentaDebito, capitalInteres, interesMora, otrosCargos, impuestos, total) {
    
        var _url = comprobantes + "comprobantes/v2/prestamos";
    
    
        var data = JSON.stringify({
          titulo: titulo,
          nroOperacion: nroOperacion,
          nroSocioTitular: nroSocioTitular,
          nroCredito: nroCredito,
          cuentaDebito: cuentaDebito,
          saldoCuentaDebito: saldoCuentaDebito,
          capitalInteres: capitalInteres,
          interesMora: interesMora,
          otrosCargos: otrosCargos,
          impuestos: impuestos,
          total: total,
        });
    
        var config = {
          method: "post",
          url: _url,
          responseType: "blob",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + AuthService.getCurrentToken(),
          },
          data: data,
        };
        return await axios(config);
      
      }

  async calcularMontoInteres (payload){
    const config = {
      method: "post",
      url: creditos + "creditos/calcular-interes-cambio-fecha",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      data: payload,
    };
    return await axios(config);
  }

  async cambiarFechaVencimientoCredito( payload ){
    const config = {
      method : "post",
      url : creditos + "creditos/cambiar-fecha-venc-credito",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      data : payload
    }
    return await axios(config);
  }

}





export default new PrestamoService();